// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSectionBody_root__2-avj"};